import React from 'react';
import "../components/HeroImage.css"

const HeroImage = (props) => {
    return (
        <div className='hero-img'>
            <div className='heading'>
                <h1>{props.titel}</h1>
                <p>{props.text}</p>
            </div>
        </div>
    );
}

export default HeroImage;
